import { render, staticRenderFns } from "./BusMessagePush.vue?vue&type=template&id=55f515ad"
import script from "./BusMessagePush.vue?vue&type=script&lang=js"
export * from "./BusMessagePush.vue?vue&type=script&lang=js"
import style0 from "./BusMessagePush.vue?vue&type=style&index=0&id=55f515ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports